module.exports = __webpack_public_path__ + "img/1572221069.8576f30b.jpg";